import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gap: theme.spacing(3),
  },
}));

export default useStyles;
